import React from 'react';
import { useAppSelector } from 'src/store';
import { getAdminRoutesAvailability, getAppRoutesAvailability } from 'src/routes/state/routesSelector';
import { useLocation } from 'react-router-dom';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { Settings } from 'lucide-react';
import NestedSidebarMenuItem, { NestedSidebarMenuLeafItem } from './NestedSidebarMenuItem';

const AdminMenu = () => {
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const adminRoutesAvailability = useAppSelector(getAdminRoutesAvailability);
    const navigate = useAppNavigation();
    const { pathname } = useLocation();

    if (!appRoutesAvailability.admin) {
        return null;
    }

    const isNatureRisk = pathname.startsWith('/admin/management/nature-risk');
    const isOneOrganisation = pathname.startsWith('/admin/management') && !isNatureRisk;

    const subItems = (
        [
            adminRoutesAvailability.gnpManagement && {
                title: 'Nature Performance',
                testId: 'admin-org-management-menu-button',
                onClick: () => navigate.toOrganisationManagement(),
                isActive: isOneOrganisation,
            },
            adminRoutesAvailability.riskPortfolio && {
                title: 'Nature Risk',
                testId: 'admin-risk-portfolio-menu-button',
                onClick: () => navigate.toRiskPortfolioAdmin(),
                isActive: isNatureRisk,
            },
            adminRoutesAvailability.userManagement && {
                title: 'User Management',
                testId: 'admin-menu-button',
                onClick: () => navigate.toUserManagement(),
                isActive: pathname.startsWith('/admin/user-management'),
            },
            adminRoutesAvailability.engineApiTokens && {
                title: 'Engine API Tokens',
                testId: 'admin-engine-api-tokens-menu-button',
                onClick: () => navigate.toEngineApiTokens(),
                isActive: pathname.startsWith('/admin/engine-api-tokens'),
            },
        ] as (NestedSidebarMenuLeafItem | false)[]
    ).filter((item): item is NestedSidebarMenuLeafItem => Boolean(item));

    if (subItems.length === 0) {
        return null;
    }

    const isAdminActive = subItems.some(item => item.isActive);

    return (
        <NestedSidebarMenuItem
            label='Admin'
            testId='admin-menu-group-button'
            icon={<Settings />}
            isActive={isAdminActive}
            defaultOpen={isAdminActive}
            subItems={subItems}
        />
    );
};

export default AdminMenu;
